import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface BarChartProps {
  data: Array<{ name: string; value?: number; tours?: number; users?: number }>;
  title?: string;
  color?: string;
}

const BarChart: React.FC<BarChartProps> = ({ data, title, color = '#10B981' }) => {
  // Check if data has tours and users (for comparison chart)
  const hasMultipleSeries = data.length > 0 && data[0].tours !== undefined && data[0].users !== undefined;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      {title && (
        <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      )}
      <ResponsiveContainer width="100%" height={300}>
        <RechartsBarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="name" 
            stroke="#6B7280"
            fontSize={12}
          />
          <YAxis 
            stroke="#6B7280"
            fontSize={12}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          {hasMultipleSeries ? (
            <>
              <Bar 
                dataKey="tours" 
                fill="#10B981"
                radius={[4, 4, 0, 0]}
                name="Tours"
              />
              <Bar 
                dataKey="users" 
                fill="#3B82F6"
                radius={[4, 4, 0, 0]}
                name="Users"
              />
            </>
          ) : (
            <Bar 
              dataKey="value" 
              fill={color}
              radius={[4, 4, 0, 0]}
            />
          )}
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChart; 